import React from 'react';
import { Confirm } from 'semantic-ui-react';

export default Confirm;
